/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_storage_capacity = /** @type {(inputs: {}) => string} */ () => {
	return `Kapacita úložiště`
};

const da_attributes_storage_capacity = /** @type {(inputs: {}) => string} */ () => {
	return `Capacité de stockage`
};

const de_attributes_storage_capacity = /** @type {(inputs: {}) => string} */ () => {
	return `Speicherkapazität`
};

const en_attributes_storage_capacity = /** @type {(inputs: {}) => string} */ () => {
	return `Capacité de stockage`
};

const es_attributes_storage_capacity = /** @type {(inputs: {}) => string} */ () => {
	return `capacidad de almacenamiento`
};

const fr_attributes_storage_capacity = /** @type {(inputs: {}) => string} */ () => {
	return `Capacité de stockage`
};

const hu_attributes_storage_capacity = /** @type {(inputs: {}) => string} */ () => {
	return `Capacité de stockage`
};

const it_attributes_storage_capacity = /** @type {(inputs: {}) => string} */ () => {
	return `Capacità di archiviazione`
};

const nl_attributes_storage_capacity = /** @type {(inputs: {}) => string} */ () => {
	return `Opslagcapaciteit`
};

const pl_attributes_storage_capacity = /** @type {(inputs: {}) => string} */ () => {
	return `Pojemność pamięci masowej`
};

const pt_attributes_storage_capacity = /** @type {(inputs: {}) => string} */ () => {
	return `Capacidade de armazenamento`
};

const sv_attributes_storage_capacity = /** @type {(inputs: {}) => string} */ () => {
	return `Lagringskapacitet`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_storage_capacity = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_storage_capacity(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_storage_capacity", locale)
	if (locale === "cs") return cs_attributes_storage_capacity(inputs)
	if (locale === "da") return da_attributes_storage_capacity(inputs)
	if (locale === "de") return de_attributes_storage_capacity(inputs)
	if (locale === "en") return en_attributes_storage_capacity(inputs)
	if (locale === "es") return es_attributes_storage_capacity(inputs)
	if (locale === "fr") return fr_attributes_storage_capacity(inputs)
	if (locale === "hu") return hu_attributes_storage_capacity(inputs)
	if (locale === "it") return it_attributes_storage_capacity(inputs)
	if (locale === "nl") return nl_attributes_storage_capacity(inputs)
	if (locale === "pl") return pl_attributes_storage_capacity(inputs)
	if (locale === "pt") return pt_attributes_storage_capacity(inputs)
	return sv_attributes_storage_capacity(inputs)
};
export { attributes_storage_capacity as "attributes.storage_capacity" }